import React, {Component} from 'react';
import moment from 'moment';
import 'moment/locale/tr';
import {Col, Row} from 'reactstrap';
import {validateField} from "../../../common/validation";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import DefaultModal from "../../invoice/DefaultModal";
import Alert from "react-s-alert";
import Select from "../../../local_node_modules/react-select"
import axios from 'axios';
import TextOverFlowTooltip from "../../../components/TextOverFlowTooltip";

class SendMultipleModal extends Component {

	constructor(props){
		super(props);
		this.state={
			error:{},
			process:false ,
			documentList:[],
			recordIds:[],
			xslts:[],
			prefixes:[],
			index:0,
			realIndex:0
		};
		this.validateField 	= this.validateField.bind(this);
		this.onCancel 		= this.onCancel.bind(this);
		this.sendNextDocument = this.sendNextDocument.bind(this);
	}

	componentWillMount() {
		this.setState({recordIds:this.props.recordIds, sendType:this.props.sendType});
	}

	componentDidMount() {
		let self = this;
		let params = {
			url: `/${this.props.type==="despatch" ? "despatches" : (this.props.type==="depoIade" ? "depoIade" : (this.props.type === "sigorta" ? "sigorta" : this.props.type+"Tmp"))}/getDocumentsWithRecordIds`,
			method: 'post',
			data: {
				recordIds:(self.props.recordIds ? self.props.recordIds:[]),
				sendType:self.props.sendType,
				profileId:self.props.profileId
			}
		};
		self.setState({btnDisabled:true,process:true});
		request(params)
		.then(function (response) {
			let prefixes 	 = response.data.prefixes;
			let xslts 		 = response.data.xslts;
			let documentList = response.data.documentList;

			let selectedPrefix 	= prefixes.length 	=== 0 ? undefined :prefixes[0];
			let selectedXslt   	= xslts.length 		=== 0 ? undefined :xslts[0].xsltFilepath;
			self.setState({
				btnDisabled: false,
				documentList: documentList,
				selectedPrefix: selectedPrefix,
				selectedXslt: selectedXslt,
				prefixes: prefixes,
				xslts: xslts,
				process: false
			});
		}).catch(function (error) {
			self.setState({btnDisabled:false,process:false});
			showAxiosError(error);
		});
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	sendNextDocument(index){
		let self= this;
		this._source = axios.CancelToken.source();
		let documentList = deepCopyObject(self.state.documentList);
		if(index < documentList.length){
			let document = documentList[index];
			document.selectedXslt = self.state.selectedXslt;
			document.selectedPrefix = self.state.selectedPrefix;

			if (!document.selectedPrefix) {
				let errorMessage = '';
				if (self.props.type === "despatch") {
					errorMessage = 'Ayarlar kısmından İrsaliye Ön Eki tanımlamalısınız.';
				} else if (self.props.type === "invoice") {
					errorMessage = 'Ayarlar kısmından Fatura Ön Eki tanımlamalısınız.';
				} else if (self.props.profileId === "EDOVIZBELGE") {
					errorMessage = 'Ayarlar kısmından Makbuz Ön Eki tanımlamalısınız.';
				} else if (self.props.type === "voucher") {
					errorMessage = 'Ayarlar kısmından Makbuz Ön Eki tanımlamalısınız.';
				} else if (self.props.type === "sigorta") {
					errorMessage = 'Ayarlar kısmından Sigorta Ön Eki tanımlamalısınız.';
				} else {
					errorMessage = 'Belge Ön Eki seçili değil, lütfen Belge Ön Eki seçiniz.';
				}
				Alert.error(errorMessage, {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000,
					html: false
				});
				return;
			}

			document.proifleId = self.props.profileId;
			let params = {
				url: `/${this.props.type==="despatch" ? "despatches" : this.props.type==="depoIade" ? "depoIade" :  this.props.profileId==="EDOVIZBELGE" ? "exchange" : this.props.type === "sigorta" ? "sigorta" : this.props.type+"Tmp"}/sendNextDocument`,
				method: 'post',
				cancelToken: self._source.token,
				data: deepCopyObject(document)
			};

			document.status = "processing";
			document.statusText = "Gönderim Başlatıldı.";
			documentList[index]=document;
			self.setState({btnDisabled:true,documentList:documentList});
			request(params)
			.then(function (response) {
				let document = response.data;
				document.status = "success";
				document.statusText = "Gönderim Başarılı";
				documentList[index]= document;
				if (self.props && self.props.updateDocumentNumberWs) {
					self.props.updateDocumentNumberWs(document.recordId,document)
				}
				self.setState({documentList,index: (index+1)});
				if(index + 1 < documentList.length){
					if((index+1) % 5 === 0){
						documentList.splice(0,4);
						self.setState({realIndex:(self.state.realIndex+4)});
						self.sendNextDocument((index+1)-4);
					}else{
						self.sendNextDocument(index+1);
					}
				}else{
					self.setState({btnDisabled:false,index: index+1});
					self.props.toggleModal(true,true);
					return;
				}
			}).catch(function (error) {
				if (axios.isCancel(error)) {

				}else{
					document.status = "error";
					document.statusText = "Gönderim Başarısız";
					documentList[index]= document;
					self.setState({documentList:documentList,btnDisabled:false});
					showAxiosError(error);
				}
				return;
			});
		}else{
			Alert.warning('Tüm dokümanlar gönderildi.', {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
			return;
		}
	}

	onCancel(){
		if(this._source)
			this._source.cancel();

		if(this.state.index > 0){
			this.props.toggleModal(false,true);
		}else{
			this.props.toggleModal(false,false);
		}
	}

	getStatusRender(status) {
		let className =(status === "processing" ? "spinner fa-spin" : (status==="success" ? "check" :(status==="error" ? "close":"pause")));
		let color= (status === "processing" ? "dark" : (status==="success" ? "green" :(status==="error" ? "red":"dark")));
		return (<i className={"fas fa-" + className} style={{color:color,paddingRight:"4px"}}></i>);
	}

	render(){
		return(
			<DefaultModal
				isOpen={this.props.modal}
				disabled={this.state.btnDisabled || (this.state.documentList && this.state.documentList.length ===0)}
				title={this.props.title}
				size="lg"
				modalBodyStyle={{padding: "0", minHeight: "500px"}}
				confirmBtnText="Toplu Gönder"
				cancelBtnText="İptal"
				onConfirm={(e)=>this.sendNextDocument(this.state.index)}
				onCancel={this.onCancel}>
				<Row>
					<Row className="col-sm-12" style={{marginBottom: "15px"}}>
						<Col sm={6}>
							<Col sm={12}>
								Doküman Öneki
							</Col>
							<Col sm={12}>
								<div className="form-group">
									<Select
										clearable={false}
										searchable={false}
										disabled={this.state.btnDisabled || (this.state.documentList && this.state.documentList.length ===0)}
										className="select-control"
										value={this.state.selectedPrefix}
										placeholder="Seçiniz..."
										onChange={e => {
											this.setState({selectedPrefix: e.value})
										}}
										options={this.state.prefixes.map((prefix) => ({
												value: prefix,
												label: prefix
											})
										)}
									/>
								</div>
							</Col>
						</Col>
						<Col sm={6}>
							<Col sm={12}>
								XSLT
							</Col>
							<Col sm={12}>
								<div className="form-group">
									<Select
										clearable={false}
										disabled={this.state.btnDisabled || (this.state.documentList && this.state.documentList.length ===0)}
										className="select-control"
										value={this.state.selectedXslt}
										placeholder="Seçiniz..."
										onChange={e => {
											this.setState({selectedXslt: e.value})
										}}
										options={this.state.xslts.map((xslt) => ({
												value: xslt.xsltFilepath,
												label: xslt.xsltFilename
											})
										)}
									/>
								</div>
							</Col>
						</Col>
					</Row>
					<Col sm="12">
						<div>
							<div className="card-body">
								<Row>
									<Col sm="12" style={{paddingRight: '5px', maxHeight:'500px', overflow:"auto"}}>
										<table className="" style={{textAlign: 'center', paddingBottom: "5px"}}>
											<thead>
												<tr style={{backgroundColor: '#ebedf0'}}>
													<th>#</th>
													<th>Tarih/Saat</th>
													{this.props.profileId !== "depoIade" &&
													<th>Unvan</th>
													}
													<th>VKN/TCKN</th>
													<th>Doküman No</th>
													<th>Durum</th>
												</tr>
											</thead>
											<tbody>
											{this.state.documentList && this.state.documentList.map((document, index) =>
												<tr key={index+"_"+document.recordId} style={{backgroundColor:(document.documentId && document.status === "success" ? "lightgreen" :"")}}>
													<td style={{margin:"0px"}}>{this.state.realIndex + (index+1)}</td>
													<td style={{margin:"0px"}}>{this.props.profileId === "depoIade" ? moment(document.date).format("DD-MM-YYYY") : moment((document.issueDate)).format("DD-MM-YYYY HH:mm:ss")}</td>
													{this.props.profileId !== "depoIade" &&
													<td style={{margin:"0px"}}>{<TextOverFlowTooltip text={document.title} maxLength={20}/>}</td>
													}
													<td style={{margin:"0px"}}>{this.props.profileId === "depoIade" ? document.sourceVknTckn : (document.vknTckn ? document.vknTckn : document.vknTcknForeignCust)}</td>
													<td style={{margin:"0px"}}>{document.documentId}</td>
													<td style={{margin:"0px"}}>{this.getStatusRender(document.status)}{(document.statusText || "Gönderim Bekliyor...")}</td>
												</tr>
											)}
											{!this.state.process && (this.state.documentList &&this.state.documentList.length === 0) &&
												<tr>
													<td colSpan="8">Kayıt bulunamadı</td>
												</tr>
											}
											{this.state.process &&
												<tr>
													<td colSpan="8">Doküman işleniyor...</td>
												</tr>
											}
											</tbody>
										</table>
									</Col>
									<Col sm="12">
										<p style={{float:"right"}}>Toplam Doküman Adeti: {this.state.documentList ? this.state.documentList.length : 0}</p>
									</Col>
								</Row>
							</div>
						</div>
					</Col>
				</Row>
			</DefaultModal>
		);
	}
}

export default SendMultipleModal;